import { useQuery, DocumentNode } from '@apollo/client';

export function useGraphQLQuery<TData>(query: DocumentNode) {
  return useQuery<TData>(query, {
    fetchPolicy: 'network-only',
  });
}
